<template>
  <v-app>
    <component :is="layout" ref="master">
      <router-view />
    </component>
    <app-dialog v-model="showDialog" title="" maxWidth="400">
      <div class="text-body-1 font-weight-medium my-5 text-center">{{ $t('message.multipleLoginError') }}</div>
      <app-button class="green-gradient-right override-disabled-styles px-15 mt-5" type="submit" invert gradient :label="$t('button.okay')" @click="showDialog = false" />
    </app-dialog>
  </v-app>
</template>

<script>
import Config from '@/config.json'

import { ProductDealType } from '@/constants/enums'
import { SHARED } from '@/constants/constants'
import { mapActions, mapState } from 'vuex'
import { PRODUCT_PRODUCTS_BY_DEAL_TYPE } from '@/store/product.module'
import { ORDER_GET_CART_ITEM } from '@/store/order.module'

export default {
  name: 'App',
  data() {
    return {
      showDialog: false
    }
  },
  mounted() {
    this.$root.$global = this

    OneSignal.push(() => {
      OneSignal.init({
        appId: Config.ONE_SIGNAL_APPID,
        safari_web_id: Config.ONE_SIGNAL_SAFARI_WEB_ID,
        notificationClickHandlerMatch: 'origin',
        notificationClickHandlerAction: 'focus',
        persistNotification: false,
        allowLocalhostAsSecureOrigin: true
      })
    })

    window.onunhandledrejection = (event) => {
      event.preventDefault()

      // Handle unauthorized user
      if (event.reason != undefined && event.reason.code == 401 && !this.showDialog) {
        this.showDialog = true
        this.logout()
        this.$router.push({ name: this.$constants.ROUTE_NAME.HOME })
      } else {
        // console.log(event.reason)
      }
    }

    // Handles changes of token in localStorage
    window.addEventListener('storage', (event) => {
      if (event.key == 'token') {
        if (this.currentUser && event.newValue == null) {
          this.showDialog = true
          this.logout()
          this.$router.push({ name: this.$constants.ROUTE_NAME.HOME })
        }
      }
    })
  },
  computed: {
    layout() {
      return this.$route.meta.layout || SHARED.DEFAULT_LAYOUT
    },
    ...mapState('auth', ['currentUser'])
  },
  created() {
    this.getLanguageList()
    this.getFlashDealProduct()
    this.getHotDealProduct()
    this.getTopPickProduct()
    this.getLandingPageData()
    this.loadProfile()
    this.getCountryList()
    this.getCartItem()
    this.fetchWishlist()
  },
  methods: {
    ...mapActions('page', ['getLandingPageData']),
    ...mapActions('auth', ['loadProfile', 'logout']),
    ...mapActions('common', ['getCountryList', 'getLanguageList']),
    ...mapActions('wishlist', ['fetchWishlist']),
    getFlashDealProduct() {
      let obj = {
        productDealType: ProductDealType.FLASH_DEALS
      }
      this.$store.dispatch(`${PRODUCT_PRODUCTS_BY_DEAL_TYPE}`, { obj })
    },
    getHotDealProduct() {
      let obj = {
        productDealType: ProductDealType.HOT_DEALS
      }
      this.$store.dispatch(`${PRODUCT_PRODUCTS_BY_DEAL_TYPE}`, { obj })
    },
    getTopPickProduct() {},
    getCartItem() {
      this.$store.dispatch(`${ORDER_GET_CART_ITEM}`)
    }
  }
}
</script>
